interface Props {
  bgColor: string
  textColor: string
  metadata: {
    title: string
    description: string
  }[]
}

function CaseStudyMetaDetails({ bgColor, textColor, metadata }: Props) {
  return (
    <section className="font-heading | relative pb-12">
      <div
        className="absolute bottom-0 h-[350px] md:h-[145px] w-full"
        style={{ background: bgColor }}
      />
      <div className="container | flex items-center flex-wrap gap-11 md:gap-22 relative z-0">
        {metadata.map(post => (
          <div key={post.title} style={{ color: textColor }}>
            <span
              className="inline-block text-base font-semibold tracking-wider uppercase  |  mb-3"
              dangerouslySetInnerHTML={{ __html: post.title }}
            />
            <span
              className="text-sm |  max-w-xs"
              dangerouslySetInnerHTML={{ __html: post.description }}
            />
          </div>
        ))}
      </div>
    </section>
  )
}

export default CaseStudyMetaDetails
